import React from "react";
import "./footer.css";
import { LinkedinLogo, Envelope } from "@phosphor-icons/react";

const Footer = () => {
  return (
    <footer className="footer-page" id="contact">
      <div className="footer-rectangle">
        {/* Footer Content */}
        <div className="footer-content-wrapper">
          <div className="footer-main">
            <div className="footer-title-row">
              <h3 className="footer-title">Let's Connect!</h3>
              <div className="footer-social">
                <a
                  href="https://www.linkedin.com/in/rachel-ma2"
                  className="footer-icon"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn profile"
                >
                  <LinkedinLogo size={22} weight="regular" />
                </a>
                <a
                  href="mailto:ma.ra@northeastern.edu"
                  className="footer-icon"
                  aria-label="Send email"
                >
                  <Envelope size={22} weight="regular" />
                </a>
              </div>
            </div>
          </div>

          <div className="footer-meta">
            <p className="footer-text">
              Made with <span className="heart">❤️</span> and React
            </p>
            <p className="footer-copyright">
              © {new Date().getFullYear()} Rachel Ma
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
